import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";

import { coverImageSelector } from "../constants";
import { CoverImage } from "./CoverImage";
import { CoverImageForm } from "./CoverImageForm";
import { MobileCoverImage } from "./MobileCoverImage";
import type { CoverImageFormValues } from "./useEditCoverImages";

export interface CoverImageFormPortalProps {
  coverImage: string;
  enabled?: boolean;
  isLoading?: boolean;
  isMobile?: boolean;
  onDelete: () => void;
  onSubmit: (values: CoverImageFormValues) => void;
  showForm?: boolean;
  thumbnailImage?: string;
}

export const CoverImageFormPortal = ({
  coverImage,
  enabled = true,
  isMobile = false,
  isLoading = false,
  onDelete,
  onSubmit,
  showForm = false,
  thumbnailImage,
}: CoverImageFormPortalProps) => {
  if (!enabled) return null;

  if (isMobile) {
    return (
      <MobileCoverImage
        thumbnailImageUrl={thumbnailImage}
        coverImageUrl={coverImage}
      />
    );
  }

  return (
    <AsyncPortal selectorQuery={coverImageSelector}>
      {showForm ? (
        <CoverImageForm
          url={coverImage}
          onSubmit={onSubmit}
          onDelete={onDelete}
          isLoading={isLoading}
        />
      ) : (
        coverImage && <CoverImage url={coverImage} />
      )}
    </AsyncPortal>
  );
};
